import styled from 'styled-components';

export const Window = styled.div`
width: 90%;
max-width: 275px;
margin-left: auto;
margin-right: auto;
`

export const TextRow = styled.p`
margin-left: 10px;
margin-right: 10px;
margin-bottom: 10px;
margin-top: 10px;
`

export const ButtonsContainer = styled.div`
margin-left: 10px;
margin-bottom: 10px;
`

export const Button = styled.button`
color: black;
margin-bottom: 10px;
`

export const List = styled.ul`
margin-bottom: 20px;
`

export const ListEntry = styled.li`
margin-bottom: 10px;
`

export const Link = styled.a`
color: black;
margin-right: 5px;
`